import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TablistContextProvider } from './TablistContext-Bpw2P1bl.js';
import { N as Nav } from './Nav-BMJljdQZ.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-jj0i00-0"
})(["position:relative;", ""], isMobile(css(["mask-image:", ";[dir='rtl'] &{mask-image:", ";}"], ({
  theme
}) => `linear-gradient(
      to right,
      ${theme.color.gray[0]},
      ${theme.color.gray[0]} calc(100% - ${theme.tabbedNavigation.scrollIndicatorWidth}),
      transparent
    )`, ({
  theme
}) => `linear-gradient(
        to left,
        ${theme.color.gray[0]},
        ${theme.color.gray[0]} calc(100% - ${theme.tabbedNavigation.scrollIndicatorWidth}),
        transparent
      )`)));
const TabbedNavigation = ({
  children,
  size = 'base',
  tablist = false,
  taktId,
  taktValue
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('tabbed-navigation')
}, /*#__PURE__*/React__default.createElement(TablistContextProvider, {
  isTablist: tablist !== null && tablist !== void 0 ? tablist : false,
  size: size
}, /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(Nav, null, children))));

export { TabbedNavigation as T };
//# sourceMappingURL=TabbedNavigation-ROsMF7Km.js.map
